module.exports = "<div style=\"display: flex; justify-content: center; align-items: center; height: 100%; width: 100%;\">\n    <img src=\"assets/layout/images/mensagem_pcd.png\" alt=\"\" />\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/area-restrita/planos/pcd-informacoes/pcd-informacoes.component.html
// module id = ../../../../../src/app/area-restrita/planos/pcd-informacoes/pcd-informacoes.component.html
// module chunks = main